import { ThemeColors } from '~/themes/colors'

export interface PhoneSettingsColors {
  TextColor: ThemeColors
  BackgroundColor: ThemeColors
  DefaultBackgroundColor: ThemeColors
}

export const phoneSettingsColors: PhoneSettingsColors = {
  TextColor: {
    default: 'gray.600',
  },
  BackgroundColor: {
    default: 'gray.100',
  },
  DefaultBackgroundColor: {
    default: 'gray.200',
  },
}
